function decodePointerPart(value: string): string {
  return value.split('~1').join('/').split('~0').join('~');
}

export function setJsonPointerValue<T>(
  document: T,
  pointer: string,
  field: string,
  value: unknown,
): T {
  const copy = structuredClone(document);
  const parts = pointer
    .split('/')
    .slice(1)
    .filter(Boolean)
    .map(decodePointerPart);
  let current: unknown = copy;
  for (const part of parts) {
    if (current == null || typeof current !== 'object') {
      throw new Error(`无效配置路径: ${pointer}`);
    }
    current = (current as Record<string, unknown>)[part];
  }
  if (current == null || typeof current !== 'object') {
    throw new Error(`无效配置路径: ${pointer}`);
  }
  (current as Record<string, unknown>)[field] = value;
  return copy;
}

export interface JsonPathChange {
  path: string;
  before: unknown;
  after: unknown;
}

export function diffJsonPaths(
  before: unknown,
  after: unknown,
  path = '$',
): JsonPathChange[] {
  if (Object.is(before, after)) return [];
  if (
    before == null ||
    after == null ||
    typeof before !== 'object' ||
    typeof after !== 'object'
  ) {
    return [{ path, before, after }];
  }
  if (Array.isArray(before) || Array.isArray(after)) {
    if (!Array.isArray(before) || !Array.isArray(after)) {
      return [{ path, before, after }];
    }
    const result: JsonPathChange[] = [];
    const length = Math.max(before.length, after.length);
    for (let i = 0; i < length; i += 1) {
      result.push(...diffJsonPaths(before[i], after[i], `${path}[${i}]`));
    }
    return result;
  }
  const left = before as Record<string, unknown>;
  const right = after as Record<string, unknown>;
  const keys = new Set([...Object.keys(left), ...Object.keys(right)]);
  const result: JsonPathChange[] = [];
  for (const key of keys) {
    result.push(...diffJsonPaths(left[key], right[key], `${path}.${key}`));
  }
  return result;
}
